import { initializeApp, getApps, getApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Check if configuration is provided
const isConfigValid = !!(
  firebaseConfig.apiKey &&
  firebaseConfig.databaseURL &&
  firebaseConfig.projectId
);

let app: ReturnType<typeof initializeApp> | undefined;
let db: ReturnType<typeof getDatabase> | null = null;
let auth: ReturnType<typeof getAuth> | null = null;
let storage: ReturnType<typeof getStorage> | null = null;
let isFirebaseActive = false;

if (isConfigValid) {
  try {
    app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
    db = getDatabase(app);
    storage = getStorage(app);
    isFirebaseActive = true;
    console.log('Firebase services (Realtime DB + Storage) successfully initialized.');
  } catch (error) {
    console.error('Error initializing Firebase:', error);
  }
} else {
  console.warn(
    'Firebase environment variables are missing or incomplete. Using localStorage fallback mode.'
  );
}

export function getFirebaseAuth() {
  if (auth) return auth;
  if (!isFirebaseActive || !app) return null;
  auth = getAuth(app);
  return auth;
}

export { db, storage, isFirebaseActive };
export type FirebaseDatabase = ReturnType<typeof getDatabase>;

/**
 * Recursively removes undefined fields from an object or array.
 * Firebase Realtime Database throws synchronous errors if any field is undefined.
 */
export function removeUndefined<T>(obj: T): T {
  if (obj === undefined) return null as any;
  return JSON.parse(JSON.stringify(obj));
}
